import React from 'react';

import {FormHelperText} from '@mui/material';
import {useField} from 'react-final-form';

const createErrors = (error) => {
    if (typeof error === 'object') {
        return Object.values(error);
    } else {
        return error;
    }
}

export function ErrorMessage({showError, meta, formHelperTextProps, helperText}) {

    if (showError) {
        return <FormHelperText {...formHelperTextProps}>{createErrors(meta.error || meta.submitError)}</FormHelperText>;
    } else if (!!helperText) {
        return <FormHelperText {...formHelperTextProps}>{helperText}</FormHelperText>;
    } else {
        return <></>;
    }
}

const config = {
    subscription: {
        error: true,
        submitError: true,
        dirtySinceLastSubmit: true,
        touched: true,
        modified: true,
        data: true,
        value: true,
    },
    value: true,
};

export const useFieldForErrors = (name) => useField(name, config);

export const showErrorOnChange = ({
                                      meta: {submitError, dirtySinceLastSubmit, error, touched, modified},
                                  }) => !!(((submitError && !dirtySinceLastSubmit) || error) && (touched || modified));

export const showErrorOnBlur = ({
                                    meta: {submitError, dirtySinceLastSubmit, error, touched},
                                }) => !!(((submitError && !dirtySinceLastSubmit) || error) && touched);
